import { CollectiblesApi, CollectibleCard, VipClaimResult } from './CollectiblesApi'
import { mockLog } from '../MockDebug'

const TAG = 'Mock Collectibles'

/** In-memory collectibles API for playground + Storybook. Always returns the
 *  same small fixture catalog; claims always succeed. */
export class MockCollectiblesApi implements CollectiblesApi {
  private cards: CollectibleCard[] = [
    {
      cardId: 'curse_of_marble_ep1_intro',
      storyId: 'curse_of_marble',
      episodeId: 'ep1',
      type: 'free',
      rarity: 'common',
      title: 'The Beginning',
      description: "Marble's first day at the academy.",
      artPath: 'Cards/curse_of_marble/ep1_intro.png',
      thumbPath: 'Cards/curse_of_marble/ep1_intro_thumb.png',
    },
    {
      cardId: 'curse_of_marble_vip',
      storyId: 'curse_of_marble',
      type: 'vip',
      rarity: 'legendary',
      title: 'Marble Ascended',
      description: 'Only for dedicated viewers.',
      artPath: 'Cards/curse_of_marble/vip.png',
      thumbPath: 'Cards/curse_of_marble/vip_thumb.png',
    },
  ]

  async listCards(): Promise<CollectibleCard[]> {
    mockLog(TAG, `listCards (${this.cards.length} cards)`)
    return [...this.cards]
  }

  async claimVipCard(seriesId: string, cardId: string): Promise<VipClaimResult> {
    mockLog(TAG, `claimVipCard series=${seriesId} card=${cardId}`)
    return { granted: true, cardId }
  }
}
